module.exports = __webpack_public_path__ + "e56fa1ab4e15879ab35eb8991f8151e3.svg";